/*
 * CMP-006 Chip/filter — Phase A1.
 * Filter chip: button[aria-pressed] toggled by click/Enter/Space (native button behaviour).
 * Applied chip: removable; the remove button and Delete/Backspace on the chip fire the same event.
 * Events (bubbling): `nc-chip:toggle` {pressed} and `nc-chip:remove` (cancelable; if not prevented the
 * chip element is removed from the DOM). Disabled chips emit nothing. No dependencies.
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('nc-chip')) return;

  class NcChip extends HTMLElement {
    connectedCallback() {
      // bound once: a moved chip (e.g. inside the fitting room's stage) must not toggle twice per click
      if (this.bound) return;
      this.main = this.querySelector('.nc-chip__main');
      this.removeBtn = this.querySelector('.nc-chip__remove');
      if (!this.main) return;
      this.bound = true;
      this.main.addEventListener('click', this.onMainClick.bind(this));
      this.main.addEventListener('keydown', this.onKeydown.bind(this));
      if (this.removeBtn) this.removeBtn.addEventListener('click', this.requestRemove.bind(this));
    }

    get isDisabled() { return this.hasAttribute('data-disabled'); }

    onMainClick() {
      if (this.isDisabled || this.main.getAttribute('aria-pressed') === null) return;
      var pressed = this.main.getAttribute('aria-pressed') !== 'true';
      this.main.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      this.dispatchEvent(new CustomEvent('nc-chip:toggle', { bubbles: true, detail: { pressed: pressed } }));
    }

    onKeydown(event) {
      if (!this.removeBtn || this.isDisabled) return;
      if (event.key === 'Delete' || event.key === 'Backspace') {
        event.preventDefault();
        this.requestRemove();
      }
    }

    requestRemove() {
      if (this.isDisabled) return;
      var ok = this.dispatchEvent(new CustomEvent('nc-chip:remove', { bubbles: true, cancelable: true }));
      if (!ok) return;
      // Keep keyboard focus inside the group: next chip, else previous, else the container.
      var target = this.nextFocusable('nextElementSibling') || this.nextFocusable('previousElementSibling');
      var container = this.parentElement;
      this.remove();
      if (target) {
        target.focus();
      } else if (container) {
        if (!container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1');
        container.focus();
      }
    }

    nextFocusable(direction) {
      var el = this[direction];
      while (el) {
        if (el.tagName === 'NC-CHIP' && !el.hasAttribute('data-disabled')) {
          return el.querySelector('.nc-chip__main');
        }
        el = el[direction];
      }
      return null;
    }
  }

  customElements.define('nc-chip', NcChip);
})();
